import {Subscription} from "rxjs";
import {filter} from "rxjs/operators";
import {
    ComponentCategory,
    ComponentElementManifest
} from "@bizform/type/model/component_element/ComponentElementManifest.model";
import {DefaultLayoutId} from "@bizform/type/model/component_element/DefaultLayoutId.model";
import {PluginType} from "@bizform/type/model/model/Plugin.model";
import {ComponentElement, ComponentElementStatic} from "@bizform/type/model/component_element/ComponentElement.model";
import {ComponentElementClass, ReactComponentElementInit, SubjectService} from "@bizform/core/dist/js/bizflow/core.min";
import {BfModalPanel} from "../bf_handler/BfModalPanel";
import * as React from "react";
import {GridSubject, GridSubjectType} from "@bizform/type/model/model/Subject.model";
import {
    GridIdKeyConstant,
    GridLinkIdKeyConstant
} from "@bizform/type/model/component_element/manifest_constant/Grid.constant";
import {Static} from "@bizform/type/decorator/Static.decorator";
import {StringHelper} from "@bizform/helper/dist/js/bizflow/helper.min";
import {GridHelper} from "./helper/Grid.helper";


/**
 * Button component element
 *
 * @since 0.0.1
 * @author Heungsoo Ham
 * @class
 */
@ComponentElementClass()
@Static<ComponentElementStatic<string>>()
export class BfGridModalContainer extends BfModalPanel {
    static readonly pluginType: string = PluginType.GRIDHANDLER;

    /* manifest */
    static readonly componentElementManifest: ComponentElementManifest = {
        uniqueId: "_0ofi1xMLbJL4an4UyiCzDVcRWpGX0Xi",
        category: ComponentCategory.HANDLER,
        defaultLayoutId: DefaultLayoutId.ONLYCOMPONENTELEMENT,
        label: "Modal Detail Container",
        description: "Modal Detail Container",
        icon: "",
        property: null
    };

    noDisplayInheritance() {
    }

    @ReactComponentElementInit(BfGridModalContainer)
    static init(): ComponentElement<string> {
        return;
    }

    private _gridSubject: Subscription;

    initDone(): void {
        if (!this._gridSubject) {
            this._gridSubject = SubjectService.gridSubject.pipe(
                filter((data: GridSubject) => this.state && this.state.wrappedCompState && data.formId === this.formId && data.type === GridSubjectType.CALLACTION && data[GridIdKeyConstant] === this.state.wrappedCompState[GridIdKeyConstant] && data[GridLinkIdKeyConstant] === this.state.wrappedCompState[GridLinkIdKeyConstant])
            ).subscribe(
                (data: GridSubject) => {
                    if (this._ref) {
                        if (data.value.startsWith("Run") && data.containerElementId !== StringHelper.elementId(this.elementId)) {
                            return;
                        }
                        GridHelper.detailContainer(this._ref, this.state.wrappedCompState, data, (this as any).___props);
                    }
                }
            );
        }
    }
}
